import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import DashboardLayout from '../../components/layout/DashboardLayout';
import MoodTracker from './components/MoodTracker';
import DiaryEntry from './components/DiaryEntry';
import DiaryTimeline from './components/DiaryTimeline';
import { diaryService } from '../../services/diary.service';
import { useAuth } from '../../context/AuthContext';
import './WellnessPage.css';
import MindfulnessButton from './components/MindfulnessButton';
import MindfulnessTimeline from './components/MindfulnessTimeline';

const WellnessPage = () => {
  const [diaryEntries, setDiaryEntries] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    let unsubscribe;

    if (user) {
      unsubscribe = diaryService.subscribeDiaryEntries(user.uid, (entries) => {
        setDiaryEntries(entries);
      });
    }

    return () => unsubscribe && unsubscribe();
  }, [user]);

  const handleSaveDiaryEntry = async (text) => {
    try {
      await diaryService.createEntry(user.uid, text);
    } catch (error) {
      console.error('Error saving diary entry:', error);
      // Handle error (show notification, etc.)
    }
  };

  return (
    <DashboardLayout>
      <div className="wellness-container">
        <div className="page-header-wrapper">
          <motion.div 
            className="page-header"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1>Wellness</h1>
            <p>Track your mood and thoughts</p>
          </motion.div>
          <div className="wellness-buttons">
            <DiaryEntry onSave={handleSaveDiaryEntry} />
            <MindfulnessButton />
          </div>
        </div>

        <div className="wellness-content">
          <div className="mood-tracker-section">
            <MoodTracker />
          </div>
          
          <div className="wellness-sections">
            <DiaryTimeline entries={diaryEntries} />
            <MindfulnessTimeline />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default WellnessPage; 